import jsPDF from 'jspdf';

export const exportSkisToPDF = (skis, user) => {
  const doc = new jsPDF();
  
  // Add title
  doc.setFontSize(20);
  doc.text('Ski Fleet Report', 105, 20, { align: 'center' });
  
  // Add user info
  doc.setFontSize(12);
  doc.text(`Athlete: ${user.name}`, 20, 35);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 20, 45);
  
  // Group skis by type
  const classicSkis = skis.filter(s => s.type === 'classic');
  const skateSkis = skis.filter(s => s.type === 'skate');
  
  let yPosition = 60;
  
  // Classic Skis Section
  if (classicSkis.length > 0) {
    doc.setFontSize(16);
    doc.text('Classic Skis', 20, yPosition);
    yPosition += 10;
    
    // Group by brand
    const groupedClassic = groupSkisByBrand(classicSkis);
    
    Object.entries(groupedClassic).forEach(([brand, brandSkis]) => {
      doc.setFontSize(14);
      doc.text(`${brand} Skis (${brandSkis.length})`, 25, yPosition);
      yPosition += 8;
      
      // Create simple table-like layout
      const headers = ['Ski #', getBrandSpecificHeaders(brand), 'Grind', 'Mold', 'Year'];
      const headerY = yPosition;
      
      // Draw headers
      doc.setFontSize(10);
      doc.setFillColor(66, 139, 202);
      doc.rect(20, headerY - 5, 170, 8, 'F');
      doc.setTextColor(255, 255, 255);
      let xPos = 25;
      headers.forEach((header, index) => {
        const width = index === 0 ? 25 : index === 1 ? 30 : 25;
        doc.text(header, xPos, headerY);
        xPos += width;
      });
      
      yPosition += 10;
      
      // Draw data rows
      doc.setTextColor(0, 0, 0);
      brandSkis.forEach((ski, index) => {
        if (yPosition > 250) {
          doc.addPage();
          yPosition = 20;
        }
        
        const rowData = [
          ski.ski_number,
          getBrandSpecificFields(ski),
          ski.grind || 'N/A',
          ski.mold || 'N/A',
          ski.year_made || 'N/A'
        ];
        
        // Alternate row colors
        if (index % 2 === 0) {
          doc.setFillColor(245, 245, 245);
          doc.rect(20, yPosition - 5, 170, 8, 'F');
        }
        
        xPos = 25;
        rowData.forEach((cell, cellIndex) => {
          const width = cellIndex === 0 ? 25 : cellIndex === 1 ? 30 : 25;
          doc.text(cell.toString(), xPos, yPosition);
          xPos += width;
        });
        
        yPosition += 8;
      });
      
      yPosition += 10;
      
      // Check if we need a new page
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      }
    });
  }
  
  // Skate Skis Section
  if (skateSkis.length > 0) {
    // Add page break if needed
    if (yPosition > 200) {
      doc.addPage();
      yPosition = 20;
    }
    
    doc.setFontSize(16);
    doc.text('Skate Skis', 20, yPosition);
    yPosition += 10;
    
    // Group by brand
    const groupedSkate = groupSkisByBrand(skateSkis);
    
    Object.entries(groupedSkate).forEach(([brand, brandSkis]) => {
      doc.setFontSize(14);
      doc.text(`${brand} Skis (${brandSkis.length})`, 25, yPosition);
      yPosition += 8;
      
      // Create simple table-like layout
      const headers = ['Ski #', getBrandSpecificHeaders(brand), 'Grind', 'Mold', 'Year'];
      const headerY = yPosition;
      
      // Draw headers
      doc.setFontSize(10);
      doc.setFillColor(66, 139, 202);
      doc.rect(20, headerY - 5, 170, 8, 'F');
      doc.setTextColor(255, 255, 255);
      let xPos = 25;
      headers.forEach((header, index) => {
        const width = index === 0 ? 25 : index === 1 ? 30 : 25;
        doc.text(header, xPos, headerY);
        xPos += width;
      });
      
      yPosition += 10;
      
      // Draw data rows
      doc.setTextColor(0, 0, 0);
      brandSkis.forEach((ski, index) => {
        if (yPosition > 250) {
          doc.addPage();
          yPosition = 20;
        }
        
        const rowData = [
          ski.ski_number,
          getBrandSpecificFields(ski),
          ski.grind || 'N/A',
          ski.mold || 'N/A',
          ski.year_made || 'N/A'
        ];
        
        // Alternate row colors
        if (index % 2 === 0) {
          doc.setFillColor(245, 245, 245);
          doc.rect(20, yPosition - 5, 170, 8, 'F');
        }
        
        xPos = 25;
        rowData.forEach((cell, cellIndex) => {
          const width = cellIndex === 0 ? 25 : cellIndex === 1 ? 30 : 25;
          doc.text(cell.toString(), xPos, yPosition);
          xPos += width;
        });
        
        yPosition += 8;
      });
      
      yPosition += 10;
      
      // Check if we need a new page
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      }
    });
  }
  
  // Add summary page
  doc.addPage();
  doc.setFontSize(16);
  doc.text('Summary', 20, 20);
  
  doc.setFontSize(12);
  doc.text(`Total Skis: ${skis.length}`, 20, 40);
  doc.text(`Classic Skis: ${classicSkis.length}`, 20, 50);
  doc.text(`Skate Skis: ${skateSkis.length}`, 20, 60);
  
  // Brand breakdown
  const brandCounts = {};
  skis.forEach(ski => {
    brandCounts[ski.brand] = (brandCounts[ski.brand] || 0) + 1;
  });
  
  doc.text('Brand Breakdown:', 20, 80);
  let brandY = 90;
  Object.entries(brandCounts).forEach(([brand, count]) => {
    doc.text(`${brand}: ${count}`, 30, brandY);
    brandY += 8;
  });
  
  // Add notes section
  doc.text('Notes:', 20, brandY + 10);
  doc.setFontSize(10);
  doc.text('• This report was generated from the Ski Fleet Management App', 20, brandY + 20);
  doc.text('• Brand-specific fields (FA/HR for Fischer, MF/H4 for Salomon/Atomic) are included', 20, brandY + 30);
  doc.text('• Contact your coach for any questions about this report', 20, brandY + 40);
  
  // Save the PDF
  const filename = `${user.name.replace(/\s+/g, '_')}_Ski_Report_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(filename);
};

// Helper functions
const groupSkisByBrand = (skis) => {
  const grouped = {};
  skis.forEach(ski => {
    if (!grouped[ski.brand]) {
      grouped[ski.brand] = [];
    }
    grouped[ski.brand].push(ski);
  });
  
  // Sort brands by number of skis (most to least)
  return Object.fromEntries(
    Object.entries(grouped).sort(([, a], [, b]) => b.length - a.length)
  );
};

const getBrandSpecificHeaders = (brand) => {
  if (brand === 'Fischer') return 'FA/HR';
  if (['Salomon', 'Atomic'].includes(brand)) return 'MF/H4';
  return 'Flex/Camber';
};

const getBrandSpecificFields = (ski) => {
  if (ski.brand === 'Fischer') {
    return `${ski.fa || 'N/A'}/${ski.hr || 'N/A'}`;
  }
  if (['Salomon', 'Atomic'].includes(ski.brand)) {
    return `${ski.mf || 'N/A'}/${ski.h4 || 'N/A'}`;
  }
  return 'N/A';
}; 